import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
import { CHECKOUT_URL, PRICE, REGULAR_PRICE, PRODUCT_NAME, PRODUCT_FULL_NAME } from '../data/offer';
const included = ['6 complete volumes (~300 landscape pages)', '139 Breath Cards in one 10-field format', '38 printable worksheets', '6 printable field cards', '5 bonuses, including the Printable Breath Card Deck', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-sand text-ink" data-id="element-162" data-mp="25ry3xfxzwgt4">
      <span id="checkout" aria-hidden="true" className="block" data-id="element-163" data-mp="20sv90obqbqyv" />
      <div className="mx-auto max-w-2xl px-5 py-16 sm:py-20" data-id="element-164" data-mp="20vhdgf3bpqcv">
        <div className="text-center" data-id="element-165" data-mp="3h5thwld5yjir">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-terra-deep" data-id="element-166" data-mp="3c8a6dt7uokui">
            Complete library
          </p>
          <h2 id="pricing-heading" className="chalk-underline mt-3 font-display text-[28px] text-sage sm:text-5xl" data-id="element-167" data-mp="3w08c62lrvc7q">
            Everything you need for every format you run
          </h2>
        </div>

        <div className="clip-corner mt-8 overflow-hidden rounded-3xl border border-sand-dark bg-white shadow-card" data-id="element-168" data-mp="9t0b3chvxrhi">
          <div className="bg-sage px-5 py-5 text-center" data-id="element-169" data-mp="eoz8tqp3slul">
            <h3 className="font-display text-xl text-cream sm:text-2xl" data-id="element-170" data-mp="3daa59ptpnp5o">
              {PRODUCT_FULL_NAME}
            </h3>
            <p className="mt-1 text-[13px] font-bold text-ochre-soft" data-id="element-171" data-mp="3i8brukqci6lw">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-172" data-mp="3rxljy0l6vpa0">
            <ProductVisual className="rounded-xl shadow-none" data-id="element-173" data-mp="3ryn2eq4jbe1r" />

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-174" data-mp="2uizk7pao26lp">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-175" data-mp="2zgr9ebjxfem7">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-sage/15" data-id="element-176" data-mp="2rguxx8i4nmb3">
                    <CheckIcon className="h-3 w-3 text-sage" aria-hidden="true" data-id="element-177" data-mp="2mijnownx79sc" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-sand-dark pt-6 text-center" data-id="element-178" data-mp="2w71o3csafevg">
              <p className="text-[13px] text-ink-soft" data-id="element-179" data-mp="28i0n2alsb607">
                Regular price{' '}
                <span className="text-ink-muted line-through" data-id="element-180" data-mp="28jts5lgr1i63">
                  ${REGULAR_PRICE} USD
                </span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-sage" data-id="element-181" data-mp="2ih7y2r51qok5">
                <span className="mt-2.5 font-display text-3xl" data-id="element-182" data-mp="2dgk8m9wgufs1">$</span>
                <span className="font-display text-6xl leading-[0.9] sm:text-7xl" data-id="element-183" data-mp="2djg3tqgxiqcs">
                  {PRICE}
                </span>
                <span className="mt-3 text-[13px] font-bold text-ink-muted" data-id="element-184" data-mp="3ox1vbia9h41h">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-185" data-mp="92hystjgpsy">
                <span className="rounded-full bg-ochre px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink" data-id="element-186" data-mp="5a9oypnuxkyk">
                  Launch price
                </span>
                <span className="rounded-full border border-sand-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-187" data-mp="3rfwupnxlvipv">
                  One-time payment
                </span>
                <span className="rounded-full border border-sand-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-188" data-mp="o07wn4nqtc1o">
                  Lifetime access
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-189" data-mp="e8lojh6pbt35">
                Get {PRODUCT_NAME} — ${PRICE}
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-190" data-mp="11xwfy825wb4m">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-191" data-mp="3f7sbbxmac7us">
                <li className="flex items-center gap-1.5" data-id="element-192" data-mp="3a7nto49n572z">
                  <LockIcon className="h-4 w-4 text-terra-deep" aria-hidden="true" data-id="element-193" data-mp="3592so2mkejdh" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-194" data-mp="3192emj3doa6y">
                  <ZapIcon className="h-4 w-4 text-terra-deep" aria-hidden="true" data-id="element-195" data-mp="1scircnv3m6i" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-196" data-mp="3t085e8x7kvjk">
                  <ShieldCheckIcon className="h-4 w-4 text-terra-deep" aria-hidden="true" data-id="element-197" data-mp="3o7ymhcuigvqs" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-198" data-mp="kjn83pdxvqwa">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}